
import { defineComponent, ref, watch, onMounted, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'

// 作品知识产权承诺函
import RightRules from './RightRules.vue'
// 大赛规则
import CompetitionRules from './CompetitionRules.vue'

export default defineComponent({
    name: 'Pop',
    props: ['type'],
    emits: ['close'],
    components: {
        RightRules,
        CompetitionRules
    },
    setup (props, context) {
        const close = () => {
            context.emit('close')
        }

        return {
            close
        }
    }
})
